import { merge, Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import background from '../assets/background.png';
import { ResponsiveSize, useResponsiveSize } from '../contexts/responsiveContext';
import Category from './Category';
import CategorySmall from './CategorySmall';

const Banner = (props) => {

    const {
        categories = [],
        customStyles = {},
        onChange = event => console.log(event),
        types = undefined
    } = props;

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                outer: {
                    root: {
                        backgroundImage: `url(${background})`,
                        backgroundPosition: "right center",
                        backgroundSize: "cover",
                        boxShadow: "inset 37.5vw 0px 200px rgba(0, 0, 0, 0.5)",
                        marginLeft: -36,
                        marginRight: -36,
                        padding: "26px 36px",
                        width: "100vw"
                    }
                },
                categories: {
                    inner: {
                        gap: 13,
                        width: 300
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        outer: {
                            root: {
                                padding: "38px 120px",
                                marginLeft: "unset",
                                marginRight: "unset",
                                width: "unset"
                            }
                        },
                        categories: {
                            inner: {
                                gap: 38,
                                width: "unset"
                            }
                        },
                    }
                );

            merge(styles, customStyles);

            return styles;
        },
        [customStyles, responsiveSize]
    );

    return <Stack styles={styles.outer}>
        <Stack horizontal styles={styles.categories} wrap>
            {Array.isArray(categories) && categories.map((category, index) => {
                const { badgeLabel, json, key, label } = category;
                const categoryProps = {
                    active: Array.isArray(types) && types.includes(key),
                    badgeLabel,
                    json,
                    key,
                    label,
                    onClick: () => onChange(key)
                };
                if (Array.isArray(types) && types.length > 0)
                    return <CategorySmall {...categoryProps} />
                else return <Category {...categoryProps} />
            })}
        </Stack>
    </Stack>;

};

export default Banner;